<template>
  <div>
    <div v-if="permission">
      <div class="data-table-title">
        <div class="data-table-description">
          リクエストの履歴と登録状況を確認できます。直近のリクエスト20件のみが表示されます。
        </div>
        <el-button
          type="primary"
          icon="el-icon-refresh-right"
          @click="loadRequest()"
          >ステータスを更新</el-button
        >
      </div>
      <div
        class="data-table-message"
        :class="header_notification ? 'header-notification-space-120' : ''"
      >
        <div class="data-table-th-ellipsis">リクエストタイトル</div>
        <div class="data-table-th-80">SNS</div>
        <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
          リクエストID
        </div>
        <div class="data-table-th-160" v-if="activate == 20 && admin_mode">
          リクエストクライアント
        </div>
        <div class="data-table-th-160">ステータス</div>
        <div class="data-table-th-60">リクエスト数</div>
        <div class="data-table-th-60">完了</div>
        <div class="data-table-th-60">取得中<br />処理中</div>
        <div class="data-table-th-60">待機中</div>
        <div class="data-table-th-60">失敗</div>
        <div class="data-table-th-140">リクエスト日時</div>
        <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
          データ取得
        </div>
        <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
          操作
        </div>
      </div>
      <div
        class="data-table-th-loading"
        v-loading="loading"
        v-if="loading"
      ></div>
      <div class="data-table-list-nolist" v-if="no_request && !loading">
        <img src="../../assets/request.png" style="opacity: 0.5" alt />
        <div style="font-size: 20px; font-weight: 700; margin-bottom: 15px">
          リクエスト履歴がありません
        </div>
        <div class="data-table-list-nolist-content">
          新規リクエストは[新規リクエスト・インポート]タブから行えます
        </div>
      </div>
      <div v-if="!loading">
        <div
          v-for="(request, request_index) in request_list"
          v-bind:key="request.id"
          class="data-table-list-tr"
          style="cursor: pointer"
          @click="openRequestDetail(request_index, request.request_id)"
        >
          <div class="data-table-th-ellipsis">
            {{ request.request_title }}
          </div>
          <div class="data-table-th-80">
            <img
              src="../../assets/ig_icon.png"
              alt
              v-if="request.sns_type == 'instagram'"
              class="data-table-sns-icon"
              style="opacity: 0.7"
            />
            <img
              src="../../assets/yt_icon.png"
              alt
              v-if="request.sns_type == 'youtube'"
              class="data-table-sns-icon"
              style="opacity: 0.7"
            />
            <img
              src="../../assets/tt_icon.png"
              alt
              v-if="request.sns_type == 'tiktok'"
              class="data-table-sns-icon"
              style="opacity: 0.7"
            />
            <img
              src="../../assets/tw_icon.png"
              alt
              v-if="request.sns_type == 'twitter'"
              class="data-table-sns-icon"
              style="opacity: 0.7"
            />
          </div>
          <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
            {{ request.request_id }}
          </div>
          <div class="data-table-th-160" v-if="activate == 20 && admin_mode">
            {{ request.client_name }}
          </div>
          <div class="data-table-th-160">
            <div
              class="status-button-small"
              :class="
                request.status == 'wait'
                  ? 'info'
                  : request.status == 'getting'
                  ? 'primary'
                  : request.status == 'finished'
                  ? 'success'
                  : 'info'
              "
            ></div>
            {{
              request.status == "wait"
                ? "待機中"
                : request.status == "getting"
                ? "データ取得中"
                : request.status == "finished"
                ? "登録完了"
                : ""
            }}
          </div>
          <div class="data-table-th-60">{{ request.request_num }}</div>
          <div class="data-table-th-60">
            {{ request.finished_num ? request.finished_num : "-" }}
          </div>
          <div class="data-table-th-60">
            {{ request.getting_num ? request.getting_num : "-" }}
          </div>
          <div class="data-table-th-60">
            {{ request.wait_num ? request.wait_num : "-" }}
          </div>
          <div class="data-table-th-60">
            {{ request.failed_num ? request.failed_num : "-" }}
          </div>
          <div class="data-table-th-140">{{ request.requested_at }}</div>
          <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
            <el-button
              :type="request.status == 'wait' ? 'primary' : 'info'"
              size="small"
              :disabled="request.status == 'wait' ? false : true"
              @click.stop="
                scrapingRequest(
                  request.request_id,
                  request.request_title,
                  request.request_num,
                  request.client_name
                )
              "
            >
              {{ request.status == "wait" ? "データ取得" : "登録完了" }}
            </el-button>
          </div>
          <div class="data-table-th-120" v-if="activate == 20 && admin_mode">
            <el-button
              type="info"
              size="small"
              @click.stop="
                deleteRequest(
                  request.request_id,
                  request.request_title,
                  request.request_num,
                  request.client_name
                )
              "
              >履歴削除</el-button
            >
          </div>
        </div>
      </div>

      <!-- drawer -->
      <div
        class="bulk-detail-modal"
        :class="[request_detail_modal ? 'open' : '']"
      >
        <div v-if="request_detail_modal" style="width: 100%">
          <div class="bulk-detail-title" v-if="checkList.length == 0">
            リクエスト履歴
          </div>
          <div class="bulk-detail-title sticky" v-show="checkList.length > 0">
            <div
              class="check-wrap"
              style="display: flex; width: calc(100% - 20px)"
            >
              <div class="check-parts" style="color: #666">
                {{ checkList.length }}名を選択中
              </div>
              <div class="check-parts pointer" @click="checkAll()">
                <i
                  class="el-icon-circle-plus-outline"
                  style="font-size: 14px"
                ></i
                >全員を選択
              </div>
              <div class="check-parts pointer" @click="checkList = []">
                <i class="el-icon-remove-outline" style="font-size: 14px"></i
                >全員の選択を解除
              </div>
              <div class="flex-space"></div>
              <addListButton
                :checkList.sync="checkList"
                :sns_type="request_list[request_index].sns_type"
              />
            </div>
          </div>
          <div
            class="bulk-detail-notifybox primary"
            v-if="activate == 20 && admin_mode"
          >
            <font-awesome-icon
              :icon="['fas', 'exclamation-triangle']"
              style="margin-right: 5px"
            />管理者モード
            <div>ID: {{ request_list[request_index].request_id }}</div>
            <div class="flex-space"></div>
            <el-button
              type="success"
              size="small"
              @click="finishRequest()"
              v-if="request_list[request_index].status == 'getting'"
              >完了処理</el-button
            >
          </div>

          <div class="bulk-detail-subtitle">リクエストタイトル</div>
          <div class="bulk-detail-box">
            <div class="bulk-detail-content">
              {{ request_list[request_index].request_title }}
            </div>
          </div>
          <div class="bulk-detail-subtitle">登録完了時のメール通知</div>
          <div class="bulk-detail-box">
            <div class="bulk-detail-content">
              {{
                request_list[request_index].email_is_required == 1
                  ? "通知する"
                  : "通知しない"
              }}
              <span v-if="request_list[request_index].email_is_required == 1"
                >({{ request_list[request_index].email_to }})</span
              >
            </div>
          </div>
          <div class="bulk-detail-subtitle row">リクエストアカウント</div>
          <div
            class="data-table-th-loading"
            v-loading="detail_loading"
            v-if="detail_loading"
          ></div>
          <div class="bulk-detail-box" style="margin-top: 15px">
            <div
              class="bulk-detail-recipient"
              v-for="influencer in influencer_list"
              :key="influencer.id"
            >
              <div class="data-table-th-checkbox">
                <input
                  type="checkbox"
                  class="checkbox-original"
                  v-model="checkList"
                  :value="influencer.id"
                  :id="influencer.id + 'checkbox'"
                  :disabled="
                    admin_mode
                      ? influencer.admin_status != 'ok'
                      : !completionGettingStatuses.includes(influencer.getting_status)
                  "
                />
                <label
                  class="checkbox_inner"
                  :class="
                    (
                      admin_mode
                        ? influencer.admin_status != 'ok'
                        : !completionGettingStatuses.includes(influencer.getting_status)
                    )
                      ? 'disabled'
                      : ''
                  "
                  :for="influencer.id + 'checkbox'"
                >
                </label>
              </div>
              <el-image
                :src="influencer.profile_picture_url"
                class="data-table-profile bulk"
                style="margin-right: 10px"
              >
                <div slot="error" class="data-table-profile-noimg"></div>
              </el-image>
              <div class="bulk-detail-recipient-name">
                {{ influencer.account_name
                }}<span v-if="admin_mode">
                  | {{ influencer.post_count }}/{{
                    influencer.media_count
                  }}</span
                >
              </div>
              <div class="flex-space"></div>
              <el-tooltip
                :disabled="
                  influencer.getting_status == 'wait' ||
                  influencer.getting_status == 'ok' ||
                  influencer.getting_status == 'getting'
                "
                placement="top-end"
              >
                <div slot="content">
                  <div v-if="isFailedWithJapaneseName(influencer)">
                    日本語が含まれるURLのため登録できませんでした。<br />
                    次の手順でURLを取得して登録してください。<br />
                    手順：プロフィール概要欄の「...更に表示」をクリック→「チャンネルを共有」→「コピー」
                  </div>
                  <div v-else-if="influencer.getting_status == 'failed'">
                    ユーザー名が存在しない、フォロワー数が1,000人未満、などの理由により登録できませんでした。
                  </div>
                  <div v-else-if="influencer.getting_status == 'error'">
                    データの取得に失敗しました。
                  </div>
                  <div v-else-if="influencer.getting_status == 'finished'">
                    データの取得完了後の処理を行っています。
                  </div>
                </div>
                <div class="bulk-detail-recipient-status">
                  <div
                    class="status-button-small"
                    :class="
                      influencer.getting_status == 'wait'
                        ? 'info'
                        : influencer.getting_status == 'getting'
                        ? 'info'
                        : influencer.getting_status == 'failed'
                        ? 'danger'
                        : influencer.getting_status == 'error'
                        ? 'danger'
                        : influencer.getting_status == 'ok'
                        ? 'success'
                        : influencer.getting_status == 'finished'
                        ? 'success'
                        : 'info'
                    "
                  ></div>
                  {{
                    influencer.getting_status == "wait"
                      ? "待機中"
                      : influencer.getting_status == "getting"
                      ? "データ取得中"
                      : influencer.getting_status == "failed"
                      ? "登録不可"
                      : influencer.getting_status == "error"
                      ? "データ取得失敗"
                      : influencer.getting_status == "ok"
                      ? "新規登録完了"
                      : influencer.getting_status == "finished"
                      ? "新規登録完了"
                      : ""
                  }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div
        class="overlay"
        v-bind:class="[request_detail_modal ? 'overlay open' : 'overlay']"
        @click="closeBulkDetail()"
      ></div>
    </div>
    <unpermitted v-else />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadRequestAPI = root + "/api/request/load_request";
const loadRequestInfluencerAPI = root + "/api/request/load_request_influencer";
const finishAPI = root + "/api/request/request_finish";
const deleteRequestAPI = root + "/api/request/delete_request";
const scrapingRequestAPI = root + "/api/request/request_scraping";
import addListButton from "../list/add_list_button.vue";
import unpermitted from "./../unpermitted";

export default {
  name: "requestHistory",
  props: [],
  components: {
    addListButton,
    unpermitted,
  },
  data() {
    return {
      request_drawer: false,
      request_list: [],
      request_index: -1,
      request_id: "",
      loading: true,
      detail_loading: false,
      no_request: false,
      request_detail_modal: false,
      influencer_list: [],
      option: false,
      checkList: [],
      requestId: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.request.access;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    completionGettingStatuses() {
      return ['ok', 'finished']; // 新規登録完了とするステータス
    }
  },
  mounted() {
    this.loadRequest();
  },
  methods: {
    loadRequest() {
      this.loading = true;
      this.no_request = false;
      this.axios
        .get(loadRequestAPI, {
          params: {
            token: this.token,
            mode: this.admin_mode ? "admin_mode" : "",
          },
        })
        .then((response) => {
          this.request_list = response.data.request_list;
          if (this.request_list.length == 0) {
            this.no_request = true;
          }
          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
        .catch(() => {});
    },
    openRequestDetail(request_index, request_id) {
      this.request_index = request_index;
      this.request_id = request_id;
      this.request_detail_modal = true;
      document.documentElement.style.overflow = "hidden";
      this.loadRequestDetail();
    },
    closeBulkDetail() {
      document.documentElement.style.overflow = "auto";
      this.request_detail_modal = false;
      this.axios.cancel(this.requestId);
      this.checkList = [];
    },
    loadRequestDetail() {
      this.detail_loading = true;
      this.influencer_list = [];
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadRequestInfluencerAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            mode: this.admin_mode ? "admin_mode" : "",
            request_id: this.request_id,
          },
        })
        .then((response) => {
          this.influencer_list = response.data.influencer_list;
          this.detail_loading = false;
        })
        .catch(() => {
          this.detail_loading = false;
        });
    },
    finishRequest() {
      this.$confirm("完了通知を行いますか？", "完了処理", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
        type: "warning",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("request_id", this.request_id);
        this.axios
          .post(finishAPI, params)
          .then((response) => {
            if (response.data.status == "OK") {
              this.$alert(
                response.data.email_is_required
                  ? response.data.email_to +
                      "に完了通知メールが送信されています。"
                  : "クライアントに完了メールは送信されていません。",
                "リクエストを完了しました",
                {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                }
              );
              this.loadRequest();
            }
          })
          .catch(() => {});
      });
    },
    checkAll() {
      const allInfluencer = [];
      for (let i = 0; i < this.influencer_list.length; i++) {
        if (this.admin_mode) {
          if (this.influencer_list[i].admin_status == "ok") {
            allInfluencer.push(this.influencer_list[i].id);
          }
        } else {
          if (this.completionGettingStatuses.includes(this.influencer_list[i].getting_status)) {
            allInfluencer.push(this.influencer_list[i].id);
          }
        }
      }
      this.checkList = allInfluencer;
    },
    deleteRequest(request_id, request_title, request_num, client_name) {
      this.$confirm(
        "この操作は取り消せません。",
        request_title +
          "(" +
          client_name +
          ")(" +
          request_num +
          ")を削除しますか？",
        {
          confirmButtonText: "削除",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          type: "warning",
        }
      )
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("request_id", request_id);
          this.axios
            .post(deleteRequestAPI, params)
            .then(() => {
              this.$alert("リクエスト履歴を削除しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
              this.loadRequest();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    scrapingRequest(request_id, request_title, request_num, client_name) {
      this.$confirm(
        "この操作は取り消せません。",
        request_title +
          "(" +
          client_name +
          ")(" +
          request_num +
          ")のデータを取得しますか？",
        {
          confirmButtonText: "データ取得",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
          type: "warning",
        }
      )
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("request_id", request_id);
          this.axios
            .post(scrapingRequestAPI, params)
            .then(() => {
              this.$alert(
                "データ取得を開始しました。アカウントによっては時間程かかる場合があります。\n24時間以上経過しても取得がされていない場合は開発までご連絡ください。",
                {
                  confirmButtonText: "OK",
                  showCancelButton: false,
                  type: "success",
                }
              );
              this.loadRequest();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    isFailedWithJapaneseName(influencer) {
      const currentRequestSnsType = this.request_list[this.request_index]?.sns_type;

      if (!influencer || influencer.getting_status !== 'failed' || !influencer.account_name || currentRequestSnsType !== 'youtube') {
        return false;
      }
      try {
        const decodedName = decodeURIComponent(influencer.account_name);
        const japaneseRegex = /[ぁ-んァ-ヶ亜-熙]/u;
        return japaneseRegex.test(decodedName);
      } catch (e) {
        console.error('Failed to decode account name:', influencer.account_name, e);
        return false;
      }
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>
